import { Controller } from "@hotwired/stimulus"

// Horizontal carousel for the Recent Releases strip.
//
// The viewport is a native overflow-x container (so trackpad / touch swiping
// works for free); the arrows scroll it by whole pages of cards and disable
// themselves at each end. The whole control block is hidden when everything
// already fits on screen.
export default class extends Controller {
  static targets = ["viewport", "previous", "next", "controls"]

  connect() {
    this.onResize = () => this.update()
    window.addEventListener("resize", this.onResize)
    this.update()
  }

  disconnect() {
    window.removeEventListener("resize", this.onResize)
  }

  previous() {
    this.viewportTarget.scrollBy({ left: -this.pageWidth(), behavior: "smooth" })
  }

  next() {
    this.viewportTarget.scrollBy({ left: this.pageWidth(), behavior: "smooth" })
  }

  update() {
    const viewport = this.viewportTarget
    const maxScroll = viewport.scrollWidth - viewport.clientWidth
    const scrollable = maxScroll > 1

    if (this.hasControlsTarget) {
      this.controlsTarget.classList.toggle("hidden", !scrollable)
    }

    if (this.hasPreviousTarget) {
      this.previousTarget.disabled = !scrollable || viewport.scrollLeft <= 1
    }

    if (this.hasNextTarget) {
      this.nextTarget.disabled = !scrollable || viewport.scrollLeft >= maxScroll - 1
    }
  }

  // One page is as many whole cards as fit, minus one so the last visible card
  // carries over and the strip never jumps past something unread.
  pageWidth() {
    const viewport = this.viewportTarget
    const card = viewport.firstElementChild

    if (!card) return viewport.clientWidth

    const gap = parseFloat(getComputedStyle(viewport).columnGap) || 0
    const step = card.offsetWidth + gap
    const visible = Math.max(1, Math.floor(viewport.clientWidth / step))

    return Math.max(1, visible - 1) * step
  }
}
